'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var index$1 = require('../Icon/index.js');
var ItemImage = require('../ItemImage/ItemImage.js');
var index = require('../Language/index.js');
var Tag = require('../Tag/Tag.js');
var ItemCard_module = require('./ItemCard.module.css.js');
var index$2 = require('../StyledMarkup/index.js');
var ReturnsConfigProvider = require('../../providers/ReturnsConfigProvider.js');
var SelectItem = require('../SelectItem/SelectItem.js');
var Chip = require('../Chip/Chip.js');
var Tooltip = require('../Tooltip/Tooltip.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const typeKey = {
  return: 'returnsItemListItemTagReturning',
  exchange: 'returnsItemListItemTagExchanging',
  exchangeForCredit: 'returnsItemListItemTagExchangingForCredit',
  claim: 'returnsItemListItemTagClaiming'
};
const ItemCardC = _ref => {
  let {
    thumbnail,
    title,
    subtitle,
    attributes,
    additionalInfo,
    onClick,
    selected,
    disabled,
    clickable,
    sTag,
    sDefault,
    layout,
    borderless,
    returnType,
    hasShippingProtection
  } = _ref;
  const {
    bodytextDefaultNone,
    headersMediumNone
  } = nthHookTheme.useTheme();
  const {
    fitItemThumbnail,
    fitItemThumbnailPosition
  } = ReturnsConfigProvider.useReturnsConfig();
  return /*#__PURE__*/React__default["default"].createElement(Tag["default"], {
    tagContent: selected && returnType ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: typeKey[returnType]
    }), /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
      icon: "CheckMark",
      fill: "#ffffff",
      width: "11",
      height: "11",
      style: {
        marginLeft: '8px'
      }
    })) : null,
    s: {
      fontFamily: bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.fontFamily,
      zIndex: 10,
      ...sTag
    },
    anchor: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, /*#__PURE__*/React__default["default"].createElement(SelectItem["default"], {
    onClick: () => {
      if (clickable && onClick) {
        onClick();
      }
    },
    customStyle: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      width: '100%',
      textAlign: layout && layout === 'vertical' ? 'center' : 'left',
      flexDirection: layout && layout === 'vertical' ? 'column' : 'row',
      ...(disabled ? {
        opacity: 0.5
      } : {}),
      ...sDefault
    },
    selected: selected,
    readOnly: !clickable || disabled,
    borderless: borderless
  }, /*#__PURE__*/React__default["default"].createElement(ItemImage["default"], {
    src: thumbnail,
    alt: title || '',
    fit: fitItemThumbnail,
    objectPosition: fitItemThumbnailPosition
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: ItemCard_module["default"].itemInfo,
    style: {
      alignItems: layout && layout === 'vertical' ? 'center' : 'flex-start'
    }
  }, hasShippingProtection && /*#__PURE__*/React__default["default"].createElement(Chip["default"], {
    fill: "rgba(40, 167, 69, 0.10)",
    color: (bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.color) ?? '#0E0E0E',
    rounded: "large",
    icon: /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
      icon: "ShippingProtection"
    }),
    action: /*#__PURE__*/React__default["default"].createElement(Tooltip["default"], {
      title: /*#__PURE__*/React__default["default"].createElement(index["default"], {
        langKey: "returnsItemListItemTagHasShippingProtectionTooltip"
      })
    }, /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
      icon: "HelpCircle"
    }))
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsItemListItemTagHasShippingProtection"
  })), /*#__PURE__*/React__default["default"].createElement("h4", {
    className: ItemCard_module["default"].itemName,
    style: headersMediumNone
  }, /*#__PURE__*/React__default["default"].createElement(index$2["default"], {
    content: title
  })), subtitle && /*#__PURE__*/React__default["default"].createElement("p", {
    className: ItemCard_module["default"].itemInfoDetail,
    style: {
      justifyContent: layout && layout === 'vertical' ? 'center' : 'flex-start',
      padding: 0,
      fontWeight: '700',
      fontSize: (bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.fontSize) ?? '14px',
      lineHeight: (bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.lineHeight) ?? '20px'
    }
  }, /*#__PURE__*/React__default["default"].createElement(index$2["default"], {
    content: subtitle
  })), attributes === null || attributes === void 0 ? void 0 : attributes.map((attr, i) => /*#__PURE__*/React__default["default"].createElement("p", {
    className: ItemCard_module["default"].itemInfoDetail,
    style: {
      justifyContent: layout && layout === 'vertical' ? 'center' : 'flex-start',
      padding: 0,
      fontSize: (bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.fontSize) ?? '14px',
      lineHeight: (bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.lineHeight) ?? '20px'
    },
    key: attr.key ?? `detail-${i}`
  }, attr.key, attr.transaction ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("s", {
    style: {
      color: '#999999'
    }
  }, attr.transaction.before), /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    icon: "ArrowRight",
    height: "20",
    width: "20"
  }), attr.transaction.after) : attr.value)), additionalInfo && /*#__PURE__*/React__default["default"].createElement("p", {
    className: ItemCard_module["default"].itemInfoDetail,
    style: {
      justifyContent: layout && layout === 'vertical' ? 'center' : 'flex-start',
      padding: '4px 0 0 0',
      fontWeight: '700',
      fontSize: (bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.fontSize) ?? '14px',
      lineHeight: (bodytextDefaultNone === null || bodytextDefaultNone === void 0 ? void 0 : bodytextDefaultNone.lineHeight) ?? '20px'
    }
  }, /*#__PURE__*/React__default["default"].createElement(index$2["default"], {
    content: additionalInfo
  })))));
};
const ItemCard = nthHookTheme.withThemeProvider(ItemCardC, {
  themeTokens: ['bodytextDefaultNone', 'captiontextDefaultNone', 'headersMediumNone', 'headersSmallNone']
});

exports.ItemCard = ItemCard;
